import React from 'react';
import { Dropdown, Grid, Input, Card, Icon, Search, Popup } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import DeleteIcon from '@material-ui/icons/Delete';
import Info from '@material-ui/icons/Info';
import Mrp from '../../PurchaseAndStock/PurchaseDetails/mrp';
import _ from 'lodash';

const style = {
  oneLine: {
    display: 'block', textOverflow: 'ellipsis', wordWrap: 'break-word',
    overflow: 'hidden', maxHeight: '3.6em', lineHeight: '1.8em',
  }
}

class Title extends React.Component {

  state = {
    quantity: 0, discount: 0, openRelatedInfo: false,
    partcode: [], partcodeOption: [], search: '',
    partcodeOptions: [],
  }

  componentDidMount() {
    let context = this;
    $("#discount"+context.props.id).keyup(function(event) {
      if (event.keyCode === 9) { context.props.addItem(); }
    });
  }

  partcode = event => {
    let value = event.target.value;
    let dropdown =  event.target.value;
    let brand_Name = value.split('->')[3];
    value = value.split('->')[0];
    let data = this.props.partcodeData;
    let aliasId, mrp, tax, partno, partname, point, brand_id, brand_name, ava_stocks, weight, rackno, part_id, adjstock, discountper;
    data.map((z) => {
      if (value == z.part_alias && brand_Name == z.brand_name) {
        adjstock = z.adjstock;
        aliasId = z.id; part_id = z.part_id; mrp = z.mrp; 
        tax = z.tax; partno = z.partno; partname = z.spare_name;
        point = z.point; weight = z.weight; rackno = z.rackno; discountper = z.discount ? z.discount : 0;
        brand_id = z.brand_id; brand_name = z.brand_name; ava_stocks = z.ava_stocks;
      }
    })
    let items = this.props.allItems;
    point = Number(point);
    let allow = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == this.props.id) {
        items[i].aliasId = aliasId; items[i].status = 'Waiting';
        items[i].partcode = value; items[i].uprice = mrp;
        items[i].adjstock = adjstock;
        items[i].tax = tax; items[i].partno = partno;
        items[i].partname = partname; items[i].point = point;
        items[i].brand = brand_id; items[i].brand_name = brand_name;
        items[i].part_id = part_id; items[i].branch = this.props.branch;
        items[i].dropdown = dropdown; items[i].ava_stocks = ava_stocks;
        items[i].weight = weight; items[i].rackno = rackno;
        items[i].quantity = ''; allow = 1; items[i].discountper = discountper;
      }
    }
    if (allow != 0) { this.props.AddArrayValues(items); }
  };

  onChangess = (type) => (f, { value }) => {
    if (value == '') {
      value = 0;
    }
    let avaliableStocks = this.props.allData.ava_stocks;
    value = parseFloat(value);
    avaliableStocks = Number(avaliableStocks);
    if (type == 'quantity') {
      if (value <= 0) {
        document.getElementById("stocks").value = "";
        alert('You are enter Negative stocks!!!');
        return;
      }
      else { this.props.updateItem(this.props.id, type, value); }
    }
    if (type == 'discountper' || type == 'discountrs') {
      this.props.updateItem(this.props.id, type, value);
    }
  }

  handleClose() {
    this.setState({ openRelatedInfo: false });
  }

  updateItems(mrp) {
    this.setState({ mrp });
    this.props.updateItem(this.props.id, 'uprice', mrp);
  }

  remove(id) {
    let allItems = this.props.allItems;
    let items = [];
    let removedItems = this.props.removedItems;
    allItems.map((x) => {
      if (x.id == id) { removedItems.push(x); }
      else { items.push(x); }
    })
    this.props.remove(items, removedItems);
  }

  handleSearchChange = (e, { value }) => {
    let results = [];
    this.props.partcodeOption.map((c) => {
      let string = c.part_alias+'->'+c.spare_name+'->'+c.partno+'->'+c.brand_name;
      string = string.toUpperCase();
      value = value.toUpperCase();
      var available = string.includes(value);
      if (available == true) {
        results.push({ title: c.part_alias+'->'+c.spare_name+'->'+c.partno+'->'+c.brand_name})
      }
    })
    this.setState({ results })
  }

  handleResultSelect = (e, { result }) => { this.partcode(result.title); }

  convertToNumber(value) {
    try {
      value = parseFloat(value);
    } catch (e) {
      value = 0;
    }
    return value;
  }


  convertToNumber1(value) {
    try {
      value = Number(value);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  render() {
    let quantity = this.convertToNumber(this.props.allData.quantity);
    let uprice = this.convertToNumber(this.props.allData.uprice);
    let tax = this.convertToNumber(this.props.allData.tax);
    let discountPercentage = this.convertToNumber(this.props.allData.discountper);
    let discountRs = this.convertToNumber(this.props.allData.discountrs);
    let discountUprice = (uprice - ((uprice * discountPercentage)/100));
    discountUprice = (discountUprice + ((discountUprice * tax)/100));
    let discountPrice = ((uprice - ((uprice * discountPercentage)/100)) * quantity);
    let taxPrice = ((discountPrice * tax)/100);
    let taxables = (Number(discountPrice) + Number(taxPrice));
    let color = 'white';
    let textColor = 'black';
    let ava_stock = this.convertToNumber1(this.props.allData.ava_stocks);
    if (ava_stock < quantity) {
      color = '#FAD7D8';
      textColor = 'red';
    }
    return (
      <tbody>
        <Loading load={this.state.load} message={this.state.message} />
        <tr style={{backgroundColor: color, color: textColor}}>
          <td style={{overflow: 'hidden'}}><center>{this.props.count}</center></td>
          <td style={{overflow: 'hidden'}}>
            <datalist id="suggestionspartno">
                {this.props.partcodeOption.map((c) => {
                  return (
                    <option id='box'>{c.part_alias+'->'+c.spare_name+'->'+c.partno+'->'+c.brand_name}</option>
                  )
                })}
            </datalist>
            <input style={{height: 35, width: '100%', backgroundColor: color, color: textColor}} onChange={this.partcode} autoComplete="on"
            list="suggestionspartno" value={this.props.allData.dropdown} id={this.props.id}/>
          </td>
          <td><center>{this.props.allData.brand_name}</center></td>
          <td><center>{this.props.allData.rackno}</center></td>
          <td style={{overflow: 'hidden'}}>
            <Popup content={<div>{'Stock Available in Branch:  '+ava_stock}</div>} trigger={
              <Input type="number" placeholder={ava_stock} fluid
                value={this.props.allData.quantity} id='stocks'
                style={{backgroundColor: color, color: textColor}}
                onChange={this.onChangess('quantity')} focus />
            } />
          </td>
          <td style={{overflow: 'hidden'}}>
            <Input type="number" value={discountPercentage}
              style={{backgroundColor: color, color: textColor}}
              fluid onChange={this.onChangess('discountper')} id={'discount'+this.props.id} focus />
          </td>
          <td style={{overflow: 'hidden'}}>
            <Input value={discountRs} inputStyle={{backgroundColor: color, color: textColor}} fluid onChange={this.onChangess('discountrs')} focus />
          </td>
          <td style={{textAlign: 'right'}}>{discountUprice.toFixed(2)}</td>
          <td style={{textAlign: 'right'}}>{discountPrice.toFixed(2)}</td>
          <td style={{textAlign: 'right'}}>{taxPrice.toFixed(2)}</td>
          <td style={{textAlign: 'right'}}>{taxables.toFixed(2)}</td>
          <td>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <DeleteIcon  style={{fontSize: 18}} onClick={this.remove.bind(this, this.props.id)} />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                <Mrp partId={this.props.allData.part_id} partno={this.props.allData.partno} display="show"
                  partcodeOption={this.props.itemdata} updateItem={this.updateItems.bind(this)}
                  brand_id={this.props.allData.brand} allItems={this.props.allItems}
                  sampleRequestqty={this.props.allData.quantity}
                  items={this.props.items}  itemId={this.props.allData.id}
                  setPartcode={this.props.itemdata} aliasId={this.props.allData.aliasId} />
              </Grid.Column>
            </Grid>
          </td>
        </tr>
      </tbody>
    );
  }
}

export default Title;
